import { useAuth } from '../context/AuthContext';

/**
 * Backend EffectivePlan().DebugMode() ile hizalı UI kapısı.
 * Güvenlik için yalnız frontend yeterli değildir; API de DebugMode zorunlu kılar.
 */
export function useDebugMode(): boolean {
  const { user } = useAuth();
  return user?.plan === 'goodmode';
}
